import api from "@/api/api";
import { iniciarRequisicao, logout } from "@/helpers";
import { STATUS_HTTP } from "@/api/statusHTTP";

export const buscarListaDeProdutos = async (parametros) => {
  const url = `/parametrizacao/compra`;
  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.produtos;
}

export const editarLoteMinimo = async (parametros) => {
  const url = `/parametrizacao/compra/editar/lote-minimo`;
  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.produtos;
}

export const editarRessuprimento = async (parametros) => {
  const url = `/parametrizacao/compra/editar/ressuprimento`;
  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.produtos;
}

export const editarInfluenciarProjecao = async (parametros) => {
  const url = `/parametrizacao/compra/editar/influenciar-projecao`;
  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.produtos;
}

export const salvarEditarProdutos = async (parametros) => {
  const url = `/parametrizacao/compra/store-editar-itens`;
  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.produtos;
}